const accessRoute = {
  PROFILE: {
    path: "/profile",
  },
};
export default accessRoute;
